import isPathValid from './is-path-valid';
import isPathUnique from './is-path-unique';
import isPathReserved from './is-path-reserved';

export default {
  isPathValid,
  isPathUnique,
  isPathReserved,
};
